import {
    SET_DISPOSITION_PENALTY_FLAG_SAVE
} from "./DispositionPenalityFlagType";

const initialState = {
    isDispositionPenaltyFlag: null
}

const reducer = (state = initialState, action: any) => {
    if (action.type === SET_DISPOSITION_PENALTY_FLAG_SAVE) {
        return {
            ...state,
            isDispositionPenaltyFlagSaved: action.isDispositionPenaltyFlagSaved,
        }
    }
    else {
        return state;
    }
};

export default reducer;
